import { BooleanField } from 'vuex-orm-decorators'
import BaseModel from '@/data/models/BaseModel'

export default class FilterableModel extends BaseModel {
  @BooleanField(true)
  public isVisible: boolean
}
